import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import { NonFatalErrorCommand } from "slotworks/commands/error/non-fatal-error-command";
import Translations from "slotworks/i18n/translations";
import AutoplayModel from "slotworks/model/autoplay-model";
import GameState from "slotworks/model/game-state";

export function UpdateWinLossCommand() {
    const win = GameState.getCurrentGame().totalCreditsWon;
    const winLoss = GameState.getCurrentGame().getTotalWinLoss();

    if (AutoplayModel.isAutoPlaying()) {
        if (AutoplayModel.stopOnAnyWin && win > 0) {
            StopAutoplayCommand();
        } else {
            AutoplayModel.runningWinLoss += winLoss;

            const isOverSingleWinLimit = AutoplayModel.singleWinLimit > 0 && win >= AutoplayModel.singleWinLimit;
            const isOverLossLimit = AutoplayModel.lossLimit > 0 && AutoplayModel.runningWinLoss <= -AutoplayModel.lossLimit;
            const isOverTotalWinLimit = AutoplayModel.totalWinLimit > 0 && AutoplayModel.runningWinLoss >= AutoplayModel.totalWinLimit;

            if (isOverSingleWinLimit || isOverLossLimit || isOverTotalWinLimit) {
                let messageId;
                if (isOverSingleWinLimit) {
                    messageId = "aut.swl";
                }
                if (isOverLossLimit) {
                    messageId = "aut.lol";
                }
                if (isOverTotalWinLimit) {
                    messageId = "aut.twl";
                }

                const message = Translations.get(messageId);
                if (messageId && message !== messageId) {
                    NonFatalErrorCommand(message).execute();
                }

                StopAutoplayCommand();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/autoplay/update-win-loss-command.ts